import { createPlugin } from '@front/utils/alpine';
import { TDataLayerProduct, TDataLayerPromotion } from '@front/services/datalayer';

export default createPlugin((vm) => {
    vm.magic('dataLayer', () => (...data: any) => {
        window.gadl.push(data);
    });

    vm.magic('dataLayerEvent', () => (category: string, action: string) => {
        window.gadl.event(category, action);
    });

    vm.magic('dataLayerEventLab', () => (category: string, action: string, label: string) => {
        window.gadl.eventLab(category, action, label);
    });

    vm.magic('dataLayerSocialInt', () => (network: string, action: string, target: string) => {
        window.gadl.socialInt(network, action, target);
    });

    vm.magic('dataLayerDelayedProductImpression', () => (listName: string, product: TDataLayerProduct) => {
        window.gadl.delayedProductImpression(listName, product);
    });

    vm.magic('dataLayerProductClick', () => (listName: string, product: TDataLayerProduct) => {
        window.gadl.productClick(listName, product);
    });

    vm.magic('dataLayerProductDetail', () => (product: TDataLayerProduct) => {
        window.gadl.productDetail(product);
    });

    vm.magic('dataLayerCartProductAdded', () => (product: TDataLayerProduct, quantity: number = 1) => {
        window.gadl.cartProductAdded(product, quantity);
    });

    vm.magic('dataLayerCartProductRemoved', () => (product: TDataLayerProduct, quantity: number = 1) => {
        window.gadl.cartProductRemoved(product, quantity);
    });

    vm.magic('dataLayerDelayedPromotionImpression', () => (listName: string, promotion: TDataLayerPromotion) => {
        window.gadl.delayedPromotionImpression(listName, promotion);
    });

    vm.magic('dataLayerPromotionClick', () => (listName: string, promotion: TDataLayerPromotion) => {
        window.gadl.promotionClick(listName, promotion);
    });

    vm.magic('dataLayerCheckoutStep', () => (stepNumber: number, stepName: string, productList: TDataLayerProduct[]) => {
        window.gadl.checkoutStep(stepNumber, stepName, productList);
    });

    vm.magic('dataLayerCheckoutStepClick', () => (stepNumber: number, stepName: string, productList: TDataLayerProduct[], checkoutStepOption?: string) => {
        window.gadl.checkoutStepClick(stepNumber, stepName, productList, checkoutStepOption);
    });

    vm.magic('dataLayerCheckoutOption', () => (stepNumber: number, stepName: string, stepOption: string) => {
        window.gadl.checkoutOption(stepNumber, stepName, stepOption);
    });

    vm.magic('dataLayerOrderConfirmation', () => (orderId: string, orderRevenue: number, orderTax: number, orderShippingCost: number, orderCoupon?: string, customerEmail?: string, productList?: TDataLayerProduct[]) => {
        window.gadl.orderConfirmation(orderId, orderRevenue, orderTax, orderShippingCost, orderCoupon, customerEmail, productList);
    });
});
